import translationGroupService from 'src/services/TranslationGroupService';

const saveTranslationGroup = (bearerToken: string) => async (
    translationGroup: Services.Translations.V2.TranslationGroup,
): Promise<void> => {
    await translationGroupService.updateTranslationGroup(bearerToken, translationGroup);
};

export default saveTranslationGroup;
